import { render, staticRenderFns } from "./authPasswordChangeDialog.vue?vue&type=template&id=445cfb5d&scoped=true&"
import script from "./authPasswordChangeDialog.vue?vue&type=script&lang=js&"
export * from "./authPasswordChangeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445cfb5d",
  null
  
)

export default component.exports